import { OverlayContainer } from '@angular/cdk/overlay';
import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[atsOverlayContainer]',
    standalone: false
})
export class AtsOverlayContainerDirective {
	constructor(private el: ElementRef, private overlayRef: OverlayContainer) {
		this.overlayRef['atsCreateContainer'](this.el);
	}
}
